export default {
  Q20: `<div style="line-height: 1.6">
  <p>
        Pour bénéficier de MaPrimeRénov', la principale aide à la rénovation,<br />
      </p>
      <p>il faut être dans l'une de ces situations:</p>
      <ul style="padding-left: 24px; line-height: 1.7">
        <li>
          <strong>Propriétaire occupant</strong> (vous vivez dans votre
          logement)
        </li>
        <li>
          <strong>Propriétaire bailleur</strong> (un locataire vit dans votre
          logement)
        </li>
        <li>Usufruitier</li>
        <li>
          Titulaires (occupants et bailleurs) d'un droit réel conférant l'usage
          du bien
        </li>
        <li>
          Preneurs (occupants et bailleurs) d'un bail emphytéotique ou d'un bail
          à construction
        </li>
        <li>
          Propriétaires en indivision si l'ensemble des propriétaires
          indivisaires ont signé l'attestation sur l'honneur qui désigne le
          demandeur pour porter les travaux au nom de l'indivision.
        </li>
      </ul>
      <p style="padding-top: 12px">Vous n'êtes pas éligible en tant que :</p>
      <ul style="padding-left: 24px; line-height: 1.7">
        <li>Nu-propriétaire</li>
        <li>Personne morale (par exemple une société civile immobilière)</li>
      </ul>
  <div>`,

  Q57: `Cette question nous aide à déterminer les aides qui vous sont applicables :</br>
  certaines sont réservées aux propriétaires occupants, d'autres aux propriétaires bailleurs.</br>Vous possédez plusieurs logements ? N'hésitez pas à faire plusieurs simulations dans plusieurs onglets de votre navigateur.`,

  Q58: `Pour qu'il soit résidence principale, quelqu'un devra occuper le logement au moins 8 mois par an après la rénovation, et vous devrez vous engager à ce qu'il le reste pendant un certain temps.</br>La plupart des aides ne ciblent que les résidence principales, et excluent donc les résidences secondaires.`,
};
